
import { gql } from "@apollo/client";
import { AnimalInfo, PANEL_ANIMAL_FRAGMENT } from "./getAnimalCall";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";


export const CREATE_ANIMAL_INFO = gql`
  mutation CreateAnimals($domain: String!, $animals: [CreateAnimal!]!, $ifFeedCurveBaseInfoOnly: Boolean!, $ifFeedCurveInfo: Boolean!, $ifSpreading: Boolean!, $ifSkipConsumption: Boolean!, $ifSkipLastTenDaysConsumption: Boolean!) {
    animal {
      create(domain: $domain, animals: $animals) {
        code
        success
        message
        updatedValues {
          ...AnimalFields
        }
      }
    }   
  }
  ${PANEL_ANIMAL_FRAGMENT}
`

export interface BaseAnimalMutationResponse extends Def_MutationResponse {
  updatedValues: AnimalInfo[];
}

export interface CreateAnimalsResponse {
  animal: {
    create: BaseAnimalMutationResponse
  }
}

// TODO Add Location / system once that is clarified
export interface CreateAnimalParameters {
  animal_number?: number;
  animal_group_id?: number;
  condition?: number;
  animal_type?: number;
  feedcurve_id?: number;
  responder_number?: number;
  location_id?: number;
  life_number?: number;
}